import { Injectable } from '@angular/core';
import { IDataSerializer } from './interfaces';

@Injectable({
  providedIn: 'root',
})
export class ClipboardService<TInput, TOutput> {
  private _item!: TOutput | null;

  copy(item: TInput, serializer: IDataSerializer<TInput, TOutput>) {
    this._item = serializer.serialize(item);
  }

  paste(): TOutput | null {
    return this._item;
  }

  celanup() {
    this._item = null;
  }
}
